import { validateNumber, validateString } from 'avilatek-utils';
import { Tax } from '../../models';

export function validateTaxForm({ name, value }: Partial<Tax>): string {
  if (!validateString(name) || String(name).length > 127) {
    return 'El nombre del impuesto es inválido';
  }

  if (!validateNumber(value) || value < 0 || value > 100) {
    return 'El valor del impuesto es inválido';
  }

  return '';
}
